/**
 * =============================================================================
 * localization.js
 * =============================================================================
 * Handle currency & language selectors
 * =============================================================================
 */

var Localization = {
  forms: undefined,

  /**
   * Initialisation
   */
  init: function() {
    this.forms = document.querySelectorAll(".localization-form");
    Array.from(this.forms).forEach(function(element) {
      element.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }.bind(this));
  },

  onItemClick(event) {
    event.preventDefault();
    const form = event.currentTarget.closest("form");
    if(form){
      form.querySelector(".current-setting").value = event.currentTarget.dataset.value;
      form.submit();
    }
  }
}

export default Localization;